import Container from '@mui/material/Container';
import Box from '@mui/material/Box';

function CustomerInitForm() {
  return (
    <Container maxWidth="sm">
      <Box my={4}>
        <iframe
          src="https://docs.google.com/forms/d/e/1FAIpQLSfG3PWvQExdTYP81TtNLh7Ws6U3b7-U9ucjD2fnN1OjyXOAbA/viewform?embedded=true"
          width="640"
          height="844"
          frameBorder="0"
          marginHeight="0"
          title="Wirepas Customer Initialization Form"
          marginWidth="0"
        >
          Loading…
        </iframe>
      </Box>
    </Container>
  );
}

export default CustomerInitForm;
